import React, { Component } from 'react';
import InitializeAction from '../actions/2bapActions';
import BaseModule from 'component/baseUI/baseModule';
import moduleCodes from 'constants/moduleCodes';
import { withModuleCheck } from '../../../../decorators/withModuleCheck';
import { withTranslate } from '../../../../decorators/withTranslate';
import layoutShape from '../../../../shapes/layoutShape';
import PropTypes from 'prop-types';
import AppErrorContainer from '../../../../component/AppErrorContainer/AppErrorContainer';
import { withRegisteredInfoPopup } from '../../../../decorators/withRegisteredInfoPopup';
import { BAP_MODULE_INIT } from '../../../../constants/informationPopupContextCodes';
import authenticationStore from 'store/authenticationStore';
import config from '../../../../config';
import { withNotifications } from '../../../../decorators/withNotifications';
import { EvidenceMeNotificationStore } from '../stores/EvidenceMeNotificationStore';

@withTranslate(withTranslate.BUILD_A_PROFILE)
@withModuleCheck(moduleCodes.MODULE_2BAP, InitializeAction.init2BapApp)
@withNotifications(EvidenceMeNotificationStore, withTranslate.BUILD_A_PROFILE)
@withRegisteredInfoPopup([BAP_MODULE_INIT], authenticationStore.isWebClient)
class ToBuildAProfileModuleLayout extends Component {

  static propTypes = {
    ...layoutShape,
    className: PropTypes.string,
    children: PropTypes.any,
    t: PropTypes.func
  };

  static defaultProps = {
    headerData: {
      headerTitle: 'Evidence me',
      module: moduleCodes.MODULE_2BAP
    },
    menuData: {
      logoClass: 'esk-2bap-menu-module-logo',
      logoUrl: config.logoConfig.getModuleLogo(moduleCodes.MODULE_2BAP),
      module: moduleCodes.MODULE_2BAP
    }
  };

  render() {
    const { t } = this.props;

    return (
      <BaseModule
        headerData={this.props.headerData}
        title={t('Evidence me')}
        menuData={this.props.menuData}
      >
        <AppErrorContainer>
          {this.props.children}
        </AppErrorContainer>
      </BaseModule>
    );
  }

}

export default ToBuildAProfileModuleLayout;
